// @core/api/endpoints/license/rotate_signing_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RotateSigningKeyRequest,
  RotateSigningKeyResponse,
} from '../../../types/license';

const BASE_PATH = '/license';

/**
 * Rotate signing key
 * Generates a new Ed25519 key pair for license signing. Existing licenses remain valid until re-signed. Master-only operation.
 */
export async function RotateSigningKey(
  data: RotateSigningKeyRequest,
  options?: RequestOptions
): Promise<RotateSigningKeyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/licenses/signing-keys/rotate`;
  const requestOptions = options;
  return client.post<RotateSigningKeyResponse>(requestPath, data, requestOptions);
}
